import axios from 'axios'
import {host} from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import {createAsyncThunk,createSlice} from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//data inicial
const dataInicial = {
    data : {},
    fc_41: {},
    loading: false,
    productos: [],
    paginaActiva: 1,
    fc_41Map: {},
    productosMap: [],
    modoVerDetalle:false,
    modoRecibidasCorregidas:false,
    modoProceso:false,
    filesProductosMap:[]
}
//types
const LOADING = 'LOADING'
const ACTUALIZAR_FC_41_PAGINA = 'ACTUALIZAR_FC_41_PAGINA'
const RESET_DATA_EXITO = 'RESET_DATA_EXITO'
const ACTUALIZAR_FC_41_ESTATUS_EXITO = 'ACTUALIZAR_FC_41_ESTATUS_EXITO'
const AGREGAR_FC_41_EXITO_MAP='AGREGAR_FC_41_EXITO_MAP'
const AGREGAR_ANEXO_FC_41_EXITO_MAP ='AGREGAR_ANEXO_FC_41_EXITO_MAP'
const OBTENER_ID_CLIENTE_EXITO = 'OBTENER_ID_CLIENTE_EXITO'
const OBTENER_FC_41_MAP_EXITO = 'OBTENER_FC_41_MAP_EXITO'
const AGREGAR_FC_41_EXITO = 'AGREGAR_FC_41_EXITO'
const AGREGAR_FC_41_MAP_EXITO = 'AGREGAR_FC_41_MAP_EXITO'
const OBTENER_FC_41_DETALLE_EXITO_AT = 'OBTENER_FC_41_DETALLE_EXITO_AT'
const ACTUALIZAR_FC_41_EXITO = 'ACTUALIZAR_FC_41_EXITO'
const GENERAR_OFICIOS_FC41_EXITO = 'GENERAR_OFICIOS_FC41_EXITO'
const ACTUALIZAR_FC_41_SOLICITUD_MODAL_EXITO = 'ACTUALIZAR_FC_41_SOLICITUD_MODAL_EXITO'

export const obtenerFC_41SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_41_DETALLE_EXITO_AT,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_41/obtenerFormatoFC41_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)

            let fc_41_anexoproducto = []
            const documentosProductos = []
            for (let i in res.data.data.fc_41_anexoproducto) {
                res.data.data.fc_41_anexoproducto[i]['id'] = uuidv4()
                for (const j in res.data.data.fc_41_anexoproducto[i].fc_41archivoproducto) {
                    const { ...anexo } = res.data.data.fc_41_anexoproducto[i].fc_41archivoproducto[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_41archivoproducto,
                        idAnexoFK: res.data.data.fc_41_anexoproducto[i].idfc33_anexoproducto,
                        estatus: true,
                    }

                    documentosProductos.push(data)
                }
            }
            fc_41_anexoproducto.push({ data: res.data.data.fc_41_anexoproducto })
            if (res.data.data.fechavisitapropuesta) {
                let fecha = res.data.data.fechavisitapropuesta
                res.data.data.fechavisitapropuesta = moment(fecha).add(1, 'd').format('YYYY-MM-DD')
            }
            return { data: res.data.data, fc_41_anexoproducto, documentosProductos }
        } catch (error) {
            console.log(error);
        }
    }
)
const getNameFile = async (ruta) => {
    let nameFile = null
    const array = ruta.split("/")
    // const array = ruta.split("\\")//local
    nameFile = array[array.length - 1]
    return nameFile
}
export const actualizarFC_41Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_41_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const archivosParaActualizarProductos = data.archivosProductos

            const actualizarFC_41 = host + `FC_41/actualizarFormatoFC41`
            const urlActualizarArchivosProductos = host + 'FC_41/actualizarArchivoProductoFC_41'

            const res = await axios.put(actualizarFC_41, solicitud)
            for (const anexo in archivosParaActualizarProductos) {
                let resAnexo = await axios.put(urlActualizarArchivosProductos, { data: archivosParaActualizarProductos[anexo] })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarMapFC_41Accion = createAsyncThunk(
    AGREGAR_FC_41_EXITO_MAP,
    async (data) => {
        try {
            let solicitud = data.solicitud
            let productos = data.productosMap
            let archivosProductosMap = data.archivosProductosMap

            const agregarFC_41Map = host + `MapSolicitud/agregarMapFC_41_SolicitudParaBebidasConMezcalMap`
            const agregarFC_41ProductoMap = host + `MapSolicitud/agregarMapFC_41_AnexoCaracteristicasProductoMap`
            const agregarFC_41ArchivosMap = host + `MapSolicitud/agregarMapFC_41ArchivosProductos`
            const res = await axios.post(agregarFC_41Map,{data:solicitud})
            for (const i in productos){
                await axios.post(agregarFC_41ProductoMap,{data:productos[i]})
            }
            for (const i in archivosProductosMap){
                await axios.post(agregarFC_41ArchivosMap,{data:archivosProductosMap[i]})
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_41Estatus = createAsyncThunk(
    ACTUALIZAR_FC_41_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_41Map = createAsyncThunk(
    OBTENER_FC_41_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_41_SolicitudParaBebidasConMezcalMap/${solicitudId}`
            const res = await axios.get(fullUrl)

            const productosMap = await obtenerProductosMap(solicitudId)
            const solicitudMap = {
                data: res.data.data,
                productosMap: productosMap.productosMap,
                filesProductosMap: productosMap.filesProductosMap
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)
const obtenerProductosMap = async (idSolicitud) => {

    try {
        const fullUrl = host + `FC_41/obtenerFormatoFC41_ConDetalle/${idSolicitud}`
        const obtenerProductoMap = host + `MapSolicitud/obtenerMapFC_41_AnexoCaracteristicasProductoMap/`
        const obtenerFilesProductoMap = host + `MapSolicitud/obtenerMapFC_41_ArchivosProductos/`

        const res = await axios.get(fullUrl)
        let anexoProductoMap = []
        const fc_41_anexoproducto = res.data.data.fc_41_anexoproducto

        for (const anexo of fc_41_anexoproducto) {
            const resMap = await axios.get(obtenerProductoMap + anexo.idfc41_anexoproducto)
            anexoProductoMap.push(resMap.data.data)

        }
        let filesArchivosMap = []
        for (const producto of fc_41_anexoproducto) {
            for (const archivo of producto.fc_41archivoproducto) {
                const resfiles = await axios.get(obtenerFilesProductoMap + archivo.idfc_41archivoproducto)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_41archivoproducto
                    filesArchivosMap.push(resfiles.data.data)
                }
            }
        }


        return { productosMap: anexoProductoMap, filesProductosMap: filesArchivosMap }
    } catch (error) {
        console.log(error);
    }
}

export const actualizarFC_41MapSolicitud = createAsyncThunk(
    AGREGAR_FC_41_MAP_EXITO,
    async (data) => {
        try {
            const solicitud = {data: data.solicitud}
            const productos = data.productosMap
            const archivosProductosMap = data.archivosProductosMap
    
            const agregarFC_41 = host + `MapSolicitud/actualizarMapFC_41_SolicitudParaBebidasConMezcalMap`
            const urlActualizarAnexoProductos = host + 'MapSolicitud/actualizarMapFC_41_AnexoCaracteristicasProductoMap' 
            const urlActualizarFilesProductos = host + 'MapSolicitud/actualizarMapFC_41_ArchivosProductos' 
            const urlAgregarFilesProductos = host + 'MapSolicitud/agregarMapFC_41ArchivosProductos' 
    
            const res = await axios.put(agregarFC_41, solicitud)
            let idfc41_solicitudparabebidasconm = res.data.data.idfc41_solicitudparabebidasconm
            
            for (let anexo of productos) {
                let resAnexo = await axios.put(urlActualizarAnexoProductos, { data: anexo })
            }
            for (let anexo of archivosProductosMap) {
                if (anexo.idfc_41archivoproductomap != "" && anexo.idfc_41archivoproductomap != null && anexo.idfc_41archivoproductomap != undefined) {
                    let resAnexo = await axios.put(urlActualizarFilesProductos, { data: anexo })
                } else {
                    delete anexo.idfc_41archivoproductomap
                    let resAnexo = await axios.post(urlAgregarFilesProductos, { data: anexo })
                }
            }
            
            return data
        } catch (error) {
            console.log(error)
        }
    }
)
export const generarDocumentosFC_41 = createAsyncThunk(
    GENERAR_OFICIOS_FC41_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/generarOficios'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarMapAnexosFC_41Accion = createAsyncThunk(
    AGREGAR_ANEXO_FC_41_EXITO_MAP,
    async (data) => {
        try {
            const observacionesAnexo = {data: data}
            const agregarFC_41ProductosMap = host + 'MapSolicitud/agregarMapFC_41_AnexoCaracteristicasProductoMap'
            for (const anexo of observacionesAnexo.data) {
                let idfc41_anexocaracteristica = anexo.id
                delete anexo.id
                anexo.idfc41_anexocaracteristica = idfc41_anexocaracteristica
                await axios.post(agregarFC_41ProductosMap, {data: anexo})
            }  
            return true
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerIdCliente = createAsyncThunk(
    OBTENER_ID_CLIENTE_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerClientePorIdLogin/${idlogin}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

//Para guardar la información del modal en atención a clientes
export const actualizarFC_41SolicitudModal = createAsyncThunk(
    ACTUALIZAR_FC_41_SOLICITUD_MODAL_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data}
            const actualizarFC_41 = host + `FC_41/actualizarFormatoFC41`
            const res = await axios.put(actualizarFC_41, solicitud)
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const fc41Slice = createSlice({
    name: 'fc41Slice',
    initialState: dataInicial,
    reducers: {
        guardarCambiosFC_41Solicitud(state, {payload}) {
            state.fc_41 = payload
        },
        
        actualizarPaginaActivaFC_41(state,{payload}) {
            state.paginaActiva = payload
        },
        editarFC_41AnexoProducto(state, {payload}){
            const input = state.productos.data.filter(field => field.id === payload.id)
            if(input.length>0){
                input[0][payload.campo] = payload.valor
            }
        },
        resetDataFC_41(state,{payload}) {
            return dataInicial
        },  
        agregarFC_41AnexoProducto(state, {payload}){
            state.productos = payload
        },      
        setModoVerDetalleFC_41(state, { payload }) {
            state.modoVerDetalle = payload
        },
        setModoRecibidasCorregidasFC_41(state, { payload }) {
            state.modoRecibidasCorregidas = payload
        },
        setModoProcesoFC_41(state, { payload }) {
            state.modoProceso = payload
        },
    },
    extraReducers: {
        [obtenerFC_41SolicitudDetalle.fulfilled]: (state, {payload}) => {
            state.data = payload
        },
        [obtenerFC_41SolicitudDetalle.fulfilled]: (state, { payload }) => {
            state.data = payload.data
            state.fc_41 = payload.data
            state.productos = { data: payload.data.fc_41_anexoproducto }

        },
        [actualizarFC_41Estatus.fulfilled]: (state, {payload}) => {
      
        },
        [obtenerIdCliente.fulfilled]: (state, {payload}) => {
      
        },
        [agregarMapFC_41Accion.fulfilled]: (state, {payload}) => {
      
        },
        [agregarMapAnexosFC_41Accion.fulfilled]: (state, {payload}) => {
      
        }, 
        [obtenerFC_41Map.fulfilled]: (state, { payload }) => {
            state.fc_41Map = payload.data
            state.productosMap = payload.productosMap
            state.filesProductosMap = payload.filesProductosMap
        },
        [actualizarFC_41Solicitud.fulfilled]: (state, {payload}) => {
      
        },
        [actualizarFC_41MapSolicitud.fulfilled]: (state, {payload}) => {
      
        },
    },
})

//actions
export const {
    guardarCambiosFC_41Solicitud, 
    resetDataFC_41, 
    actualizarPaginaActivaFC_41,
    editarFC_41AnexoProducto,
    agregarFC_41AnexoProducto,
    setModoVerDetalleFC_41, setModoRecibidasCorregidasFC_41, setModoProcesoFC_41
} = fc41Slice.actions

export const FC41ReducerAtencionACliente= fc41Slice.reducer


